import React from 'react';

const TeacherAssistantsx2 = ({ className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="74" height="74" x="0" y="0" viewBox="0 0 74 74">
      <circle r="37" cx="37" cy="37" fill="#eae9f8" shape="circle" />
      <g transform="matrix(0.69,0,0,0.69,11.469997560977944,11.469999704360966)">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m68.77 54.08h-3.5a1 1 0 0 1 0-2h3.5a1.221 1.221 0 0 0 1.091-1.78 1.013 1.013 0 0 1 -.08-.213l-3.149-12.4a2.307 2.307 0 0 0 -2.012-1.167h-55.24a2.307 2.307 0 0 0 -2.012 1.166l-3.149 12.4a1.013 1.013 0 0 1 -.08.213 1.221 1.221 0 0 0 1.091 1.781h24.52a1 1 0 0 1 0 2h-24.52a3.221 3.221 0 0 1 -2.923-4.587l3.154-12.419a.974.974 0 0 1 .079-.211 4.3 4.3 0 0 1 3.84-2.343h55.24a4.3 4.3 0 0 1 3.84 2.343.974.974 0 0 1 .079.211l3.154 12.419a3.221 3.221 0 0 1 -2.923 4.587z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m53.37 54.08h-9.12a1 1 0 0 1 0-2h9.12a1 1 0 0 1 0 2z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m60.17 54.08h-1.7a1 1 0 0 1 0-2h1.7a1 1 0 0 1 0 2z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m55.2 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m60.351 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m50.729 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m41.472 62.662h-8.944a1 1 0 0 1 -1-1v-3.268a1 1 0 0 1 2 0v2.268h6.944v-2.268a1 1 0 0 1 2 0v3.268a1 1 0 0 1 -1 1z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m46.621 62.662h-19.242a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.521-6.518h8.2a6.525 6.525 0 0 1 6.517 6.518v4.056a1 1 0 0 1 -.996 1zm-18.242-2h17.242v-3.056a4.523 4.523 0 0 0 -4.521-4.518h-8.2a4.523 4.523 0 0 0 -4.517 4.518z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m37 48.989a5.756 5.756 0 1 1 5.756-5.755 5.762 5.762 0 0 1 -5.756 5.755zm0-9.511a3.756 3.756 0 1 0 3.756 3.756 3.76 3.76 0 0 0 -3.756-3.756z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m27.742 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m32.893 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="m23.271 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z"
          fill="#5c48d3"
        />
      </g>
    </svg>
  );
};
export default TeacherAssistantsx2;
